import React from 'react';
import styled from '@emotion/styled';
import { assetUrl } from '~/helpers';
import colours from '~/utils/colours';
import { PreviewProps } from '../../LandingPagePreview';

const UserProfileWrapper = styled.div<{ shadowed: boolean }>`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  padding: 5px;
  ${(props) => props.shadowed && 'box-shadow: 0px 3px 6px #00000029;'}
`;

const ShareBtnImage = styled.img`
  width: 15px;
  height: 15px;
  margin-left: auto;
  opacity: 0.4;
`;

const ProfileImageContainer = styled.div`
  padding: 3px;
`;

const ProfileImage = styled.img`
  border-radius: 0.3em;
  width: 2em;
  height: 2em;
  margin-right: 0.25em;
`;

const ProfileInfoName = styled.div`
  font-size: 16px;
  line-height: 1.2em;
  font-weight: bold;
  word-break: break-all;
`;

const StyledCommentText = styled.div`
  height: 0.5em;
  background-color: ${colours.greyMedium};
  border-radius: 0.6em;
  margin-top: 5px;
`;

export interface UserProfileProps
  extends Pick<PreviewProps, 'userImage' | 'userName' | 'templateType'> {
  showSocialShare?: boolean;
  shadowed?: boolean;
}

const UserProfile = ({
  userImage,
  userName,
  shadowed = false,
  showSocialShare = false,
}: UserProfileProps) => {
  return (
    <UserProfileWrapper shadowed={shadowed}>
      <ProfileImageContainer>
        <ProfileImage src={userImage} alt='Profile Image' />
      </ProfileImageContainer>
      <div>
        <ProfileInfoName>{userName || 'Your name'}</ProfileInfoName>
        <StyledCommentText />
      </div>
      {showSocialShare && (
        <ShareBtnImage src={assetUrl('assets/images/icons/ic_share.svg')} />
      )}
    </UserProfileWrapper>
  );
};

export default UserProfile;
